import React, { useEffect, useRef } from 'react';

export function Thumbnail({ page, item, doneDrawing }) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(
    () => {
      let canvas = canvasRef.current;
      let vp = page.getViewport({ scale: 1 });
      if (vp.width > 300) {
        let newScale = 300 / vp.width;
        vp = page.getViewport({ scale: newScale });
      }
      canvas.height = vp.height;
      canvas.width = vp.width;
      page
        .render({
          canvasContext: canvas.getContext('2d'),
          viewport: vp
        })
        .promise.then(() => {
          doneDrawing(item);
        });
    },
    [page, item, doneDrawing]
  );

  return <canvas id={`canvas_${item}`} ref={canvasRef} />;
}

export default Thumbnail;
